export function maskMobile(mobile: string) {
  // mask mobile except last 4 digits
  if (mobile) {
    return mobile.replace(/.(?=.{4})/g, "*");
  } else {
    return "";
  }
}
